module.exports = __webpack_public_path__ + "img/0125.17c06487.png";